
<h1 mat-dialog-title>Copy Product and Accruals</h1>
<p>Click below to select type of copy or to cancel the copy</p>
<div>
  <button mat-raised-button class="functional-button-dark" (click)="CopyApproved()"> Copy as Approved</button>
  <button mat-raised-button class="functional-button-dark" (click)="CopyPending()"> Copy as Pending</button>
  <button mat-raised-button class="functional-button" (click)="Cancel()"> Cancel</button>
</div>
